import { callApi } from "services/callApi";
import apiList from "services/apiList";   
import { setLocalStorage, getLocalStorage } from "utils/storageUtil";

export const syncAppConfig = async () => {
  try {
    const url = apiList.appEnvProps.envProps;
    const result = await callApi.get(url);

    if (result && result.data && result.data.length > 0) {
      const attributes = result.data[0].attributes || {};
      
      let configObj = { ...attributes };

      if (Array.isArray(attributes.flags)) {
        attributes.flags.forEach((item) => {
          if (item.title) configObj[item.title] = item.value;
        });
      }

      if (Array.isArray(attributes.props)) {
        attributes.props.forEach((item) => {
          if (item.title) configObj[item.title] = item.value;
        });
      }

      setLocalStorage("appConfig", configObj);
      console.log("App Config Synced:", configObj);
      return configObj;
    }
  } catch (error) {
    console.error("Error syncing app config:", error);
    return null;
  }
};

export const getAppConfig = (key) => {
  let appConfig = getLocalStorage("appConfig");

  if (appConfig) {
    return appConfig[key];
  } else {
    let config = false;
    config = process.env[`REACT_APP_${key}`];
    if (config === "true") {
      config = true;
    } else if (config === "false") {
      config = false;
    }
    return config;
  }
};